import React, { useCallback, useMemo } from 'react'

import { FormikProps, useFormikContext } from 'formik'
import { useStyles } from './ServiceAgreement.styles'
import {
  PrivateOffer,
  EulaType,
} from '../../../../../modules/privateOffer/reducer'
import { Eula } from '@labrav/marketplace'
import {
  RadioButtonGroupMapping,
  RadioButtonType,
} from '@labrav/react-components'
import {
  eulaStandardContractUrlGCP,
  eulaSubHeading,
  eulaSectionHeading,
} from '../../../../../common/utils/constants'
import type { KeyValue } from '../../../../../modules/privateOffer/privateOfferCreation/types'

export const eulaButtonOptions: RadioButtonGroupMapping[] = [
  {
    key: EulaType.STANDARD,
    label: 'STANDARD Contract for GCP Marketplace',
    type: RadioButtonType.STANDARD,
    url: eulaStandardContractUrlGCP,
  },
  {
    key: EulaType.CUSTOM,
    label: 'Custom EULA',
    type: RadioButtonType.STANDARD,
  },
]

export const ServiceAgreement = ({
  selectedEulaFiles,
  setSelectedEulaFiles,
}: {
  selectedEulaFiles: File[]
  setSelectedEulaFiles: (files: File[]) => void
}) => {
  const { values, setFieldValue, setFieldError } =
    useFormikContext() as FormikProps<PrivateOffer>
  const { classes } = useStyles()
  const eulaTooltipLabel =
    'Upload your own EULA otherwise use standard one supported by GCP.'
  const eulaProps = {
    acceptedFormats: ['application/pdf', 'text/plain'],
    acceptedFilesTextMsg: 'Use plain text .pdf files only. Max file size 10 Mb',
  }

  const setEulaFile = useCallback(
    (files: File[]) => {
      setSelectedEulaFiles(files)
    },
    [selectedEulaFiles]
  )
  const deleteLink = (index: number) => {
    const updatedFiles = [...(values?.eulaFile || [])]
    updatedFiles.splice(index, 1)
    setFieldValue('eulaFile', updatedFiles)
  }
  const disableUpload = useMemo(() => {
    if ((values?.eulaFile || []).length + selectedEulaFiles.length >= 5) {
      return true
    } else {
      return false
    }
  }, [values?.eulaFile])
  const updateEulaFileErr = (error: string) => {
    setFieldError('eulaFile', error || undefined)
  }
  const handleEulaChange = (event: KeyValue) => {
    const value = event.value
    setFieldValue('eulaType', value)
  }
  const deleteFile = useCallback(
    (index: number, key: string) => () => deleteLink(index),
    [values.eulaType]
  )
  return (
    <div className={classes.root}>
      <Eula
        selectedEulaFiles={selectedEulaFiles}
        setEulaFile={setEulaFile}
        disableUpload={disableUpload}
        handleChange={handleEulaChange}
        eulaType={values.eulaType}
        fileLinks={values.eulaFile}
        fileUploadHeading={'Service agreement documents'}
        fileUploadSubHeading={
          'Upload your custom EULA(s) for this specific private offer'
        }
        heading={eulaSectionHeading}
        subHeading={eulaSubHeading}
        tooltipLabel={eulaTooltipLabel}
        eulaOptions={eulaButtonOptions}
        showFileUploadForOptions={[
          EulaType.STANDARD,
          EulaType.PUBLIC,
          EulaType.CUSTOM,
        ]}
        shouldShowEulaOptionSelectionRadioButtons={true}
        {...eulaProps}
        updateErr={updateEulaFileErr}
        deleteLink={deleteFile}
        showRealName
        checkDuplicate
      />
    </div>
  )
}
